import { initAccordion } from "../../../../assets/js/accordion.js";

// Locaties: één tegelijk open. Zonder JS staan ze allemaal open (de dichte stand zit alleen onder [data-locations-ready]).
document.querySelectorAll("[data-locations]").forEach((root) => {
	initAccordion({ root, item: ".location", toggle: ".location-toggle", panel: ".location-panel", openClass: "is-open", readyAttr: "data-locations-ready" });
});
